module.exports = __webpack_public_path__ + "img/vinsfavoris.2f5ce966.jpg";